{
  "app": { "backoffice": "Backoffice" },
  "nav": { "dashboard": "Dashboard", "users": "Users", "organizations": "Organizations", "invoices": "Invoices", "mail": "Mail", "audit": "Audit", "insights": "Quality", "conversations": "Conversations", "offers": "Offers", "packs": "Credit packs", "prices": "Prices", "orders": "Orders", "contact": "Contact requests", "waitlist": "Waiting list", "credits": "Credits", "vat": "VAT to check", "monthly": "Month", "issues": "Issues", "sandboxes": "Sandboxes" },
  "header": { "signOut": "Sign out", "language": "Language" },
  "common": {
    "loading": "Loading…",
    "empty": "Nothing here.",
    "any": "Any",
    "yes": "Yes",
    "no": "No",
    "search": "Search",
    "reset": "Reset filters",
    "cancel": "Cancel",
    "create": "Create",
    "save": "Save",
    "saved": "Saved.",
    "delete": "Delete",
    "edit": "Edit",
    "change": "change",
    "count": "{{count}} total",
    "range": "{{from}}–{{to}} of {{total}}",
    "previous": "Previous page",
    "next": "Next page",
    "typeToConfirm": "Type “{{word}}” to confirm"
  },
  "chart": { "showTable": "Table", "showChart": "Chart", "period": "Period", "value": "Value" },
  "login": {
    "title": "Sculpt Backoffice",
    "subtitle": "Peerception staff only: sign in with your Peerception Microsoft account.",
    "microsoft": "Continue with Microsoft",
    "finishing": "Finishing sign-in…",
    "staffOnlyTitle": "Staff only",
    "staffOnlyMessage": "This account is not a Peerception staff account. Ask a colleague with backoffice access to grant it.",
    "sso": {
      "staff_only": "This Microsoft account is not a Peerception staff account.",
      "staff_tenant_only": "This Microsoft account is outside the Peerception tenant. Sign in with your Peerception Microsoft account.",
      "sso_failed": "Microsoft sign-in failed. Please try again.",
      "cancelled": "Sign-in cancelled.",
      "account_disabled": "This account is disabled."
    }
  },
  "dashboard": {
    "title": "Dashboard",
    "subtitle": "How Sculpt is doing today.",
    "usersTotal": "Users",
    "usersVerified": "Verified",
    "usersActive": "Active",
    "usersStaff": "Staff",
    "of": "of {{total}}",
    "orgsTotal": "Organizations",
    "operations": "Operations",
    "invoicesOutstanding": "Invoices outstanding",
    "invoicesDraft": "Draft invoices",
    "outboxQueued": "Mail queued",
    "outboxFailed": "Mail failed",
    "signupsPerWeek": "Signups per week",
    "spendPerMonth": "Client price of usage per month (EUR)",
    "costPerMonth": "Provider cost of customers’ calls per month (USD)",
    "internalCostPerMonth": "Provider cost of Peerception’s own calls per month (USD)"
  },
  "users": {
    "discovery": "Heard of us through",
    "discoverySource": { "linkedin": "LinkedIn", "google": "Google", "youtube": "YouTube", "word_of_mouth": "Word of mouth", "other": "Other", "invitation": "Invitation" },
    "review": { "title": "Review sample", "none": "No objection: their conversations may be picked for the review's sample.", "objectedSince": "Objection recorded {{date}}: their conversations are no longer picked.", "organizationOut": "Their organization is out of the sample since {{date}}.", "hint": "Record it when the person asks, by mail. Their conversations that failed, were reported or rated down are still reviewed; the portal shows them the status.", "record": "Record the objection", "withdraw": "Withdraw the objection", "recorded": "Objection recorded.", "withdrawn": "Objection withdrawn.", "recordTitle": "Record the objection", "recordMessage": "{{email}} objects to the review of their conversations picked at random. The reviews already picked for them are deleted." },
    "title": "Users",
    "new": "New user",
    "newSubtitle": "A staff-made account starts verified, without a password: the person chooses one through the mailed link.",
    "searchPlaceholder": "email or name",
    "email": "Email",
    "name": "Name",
    "firstName": "First name",
    "lastName": "Last name",
    "locale": "Language",
    "organization": "Organization",
    "organizationId": "Organization #",
    "organizationHint": "Leave empty for a personal organization of one.",
    "verified": "Verified",
    "active": "Active",
    "staff": "Staff",
    "spend": "Billed",
    "cost": "Provider cost",
    "requests": "Model calls",
    "lastConnection": "Last connection",
    "createdAt": "Created",
    "password": "Password",
    "ssoOnly": "none (Microsoft only)",
    "hasPassword": "set",
    "makeStaff": "Staff: may use this backoffice",
    "sendReset": "Mail a “choose your password” link",
    "account": "Account",
    "activeHint": "Active (unchecking revokes every session)",
    "staffHint": "Staff (backoffice access)",
    "verifiedHint": "Email verified (opens the agent gate)",
    "usage": "Usage",
    "identities": "Linked identities",
    "noIdentities": "No Microsoft identity linked.",
    "noOrganization": "No organization.",
    "sendResetAction": "Send password reset",
    "resetSent": "Password reset mail queued.",
    "moveAction": "Move to organization…",
    "moveTitle": "Move to another organization",
    "moveHint": "Their personal organization, if now empty, is archived. The owner of a team with members cannot be moved.",
    "moveConfirm": "Move",
    "moved": "Moved.",
    "deleteAction": "Delete account…",
    "deleteTitle": "Delete this account",
    "deleteMessage": "Threads, workbooks, identities and sessions of {{email}} are deleted. Their model spend stays with the organization. This cannot be undone.",
    "deleteConfirm": "Delete account",
    "auditTitle": "Audit trail"
  },
  "orgs": {
    "reviewSample": { "title": "Review sample", "in": "In the review's sample.", "out": "Out of the review's sample since {{date}} (set by the owner in the portal). Its conversations that failed, were reported or rated down are still reviewed." },
    "title": "Organizations",
    "new": "New organization",
    "newSubtitle": "A team organization; invite its first admin at once if you know them.",
    "searchPlaceholder": "name or billing email",
    "name": "Name",
    "kindLabel": "Kind",
    "kind": { "team": "Team", "personal": "Personal" },
    "statusLabel": "Status",
    "status": { "active": "Active", "suspended": "Suspended", "archived": "Archived" },
    "suspendedWarning": "Suspended closes the agent gate for every member at once.",
    "archivedWarning": "Archived organizations are kept for their spend and invoices; members are gated.",
    "plan": "Plan",
    "seats": "Seats",
    "seatsHint": "Recorded, not enforced.",
    "allowance": "Allowance (USD)",
    "allowanceHint": "Model spend at list price the organization may use per period.",
    "periodLabel": "Period",
    "period": { "total": "total", "month": "month" },
    "unlimited": "unlimited",
    "unlimitedHint": "Unlimited allowance",
    "billing": "Billing",
    "billingEmail": "Billing email",
    "billingEmailHint": "Invoices are mailed here; empty = the owner's address.",
    "currency": "Currency",
    "currencyHint": "What it is priced and invoiced in. Changes only while it has paid nothing: a free subscription moves to the same offer in that currency, pending orders are re-priced.",
    "changeCurrency": "Change the currency",
    "currencySaved": "The organization is now priced in {{currency}}.",
    "billingName": "Billing name",
    "billingAddress": "Billing address",
    "vat": "VAT number",
    "notes": "Staff notes",
    "notesHint": "Never shown to the organization.",
    "firstAdmin": "First admin (email)",
    "firstAdminHint": "Invited as admin as soon as the organization exists.",
    "members": "Members",
    "spend": "Billed",
    "cost": "Provider cost",
    "roleLabel": "Role",
    "role": { "owner": "Owner", "admin": "Admin", "member": "Member" },
    "tabs": { "overview": "Overview", "subscription": "Subscription", "members": "Members", "claims": "Claims", "invitations": "Invitations", "usage": "Usage", "invoices": "Invoices" },
    "joinedAt": "Joined",
    "makeOwner": "Make owner",
    "transferTitle": "Transfer ownership",
    "transferMessage": "{{email}} becomes the owner; the current owner becomes an admin.",
    "transferConfirm": "Transfer",
    "transferred": "Ownership transferred.",
    "claimsHint": "A verified claim with auto-join places every newcomer from that domain or tenant in this organization.",
    "claimKind": "Kind",
    "claim": { "domain": "Email domain", "tenant": "Microsoft tenant" },
    "claimValue": "Value",
    "autoJoin": "Auto-join",
    "claimStatus": "Status",
    "verified": "verified",
    "pending": "pending",
    "verify": "Verify",
    "claimVerified": "Claim verified.",
    "noClaims": "No claims.",
    "invite": "Invite",
    "invited": "Invitation mailed to {{email}}.",
    "sentAt": "Sent",
    "expiresAt": "Expires",
    "revoke": "Revoke",
    "noInvitations": "No pending invitation.",
    "since": "since",
    "limitReached": "allowance spent",
    "createdAt": "Created",
    "updatedAt": "Updated",
    "archivedAt": "Archived",
    "picker": "Search an organization…",
    "pickerNone": "Search an organization (or leave empty)…"
  },
  "invoices": {
    "title": "Invoices",
    "new": "New invoice",
    "newSubtitle": "A draft: nothing is mailed until you send it.",
    "number": "Number",
    "organization": "Organization",
    "statusLabel": "Status",
    "status": { "draft": "Draft", "sent": "Sent", "paid": "Paid", "void": "Void" },
    "amount": "Amount",
    "currency": "Currency",
    "description": "Description",
    "details": "Invoice",
    "periodStart": "Period start",
    "periodEnd": "Period end",
    "issuedAt": "Issued",
    "dueAt": "Due",
    "externalRef": "External reference",
    "externalRefHint": "Accounting or payment-processor id.",
    "notes": "Staff notes",
    "lines": "Lines",
    "addLine": "Add line",
    "noLines": "No lines: the amount stands alone.",
    "lineDescription": "Description",
    "quantity": "Qty",
    "unitPrice": "Unit price",
    "linesTotal": "Lines total",
    "useTotal": "Use as amount",
    "pdf": "PDF",
    "uploadPdf": "Upload PDF…",
    "replacePdf": "Replace PDF…",
    "downloadPdf": "Download PDF",
    "pdfUploaded": "PDF stored.",
    "send": "Send",
    "resend": "Send again",
    "sendTitle": "Send this invoice",
    "sendMessage": "Mails the organization's billing address with the PDF attached.",
    "sendNoPdf": "No PDF is attached yet: the mail will carry the number and the amount only. Send anyway?",
    "sent": "Invoice sent.",
    "sentTo": "to {{to}}",
    "markPaid": "Mark paid",
    "paidTitle": "Mark as paid",
    "paidAt": "Paid on",
    "paidAtHint": "Empty = today.",
    "paid": "Marked paid.",
    "void": "Void",
    "voidTitle": "Void this invoice",
    "voidMessage": "A void invoice keeps its number and cannot be sent or paid.",
    "voided": "Invoice voided.",
    "deleteTitle": "Delete this draft",
    "deleteMessage": "Only drafts can be deleted; the number is not reused.",
    "lifecycle": "Lifecycle",
    "sentAt": "Sent",
    "locked": "A sent, paid or void invoice is read-only.",
    "issuing": "being issued",
    "kind": {"label": "Kind", "invoice": "Invoice", "credit_note": "Credit note"},
    "provider": {"label": "Source", "qonto": "Qonto", "manual": "Manual"},
    "issue": {"label": "Issuing", "pending": "In progress · {{step}}", "pendingRetry": "In progress · {{step}} · attempt {{attempts}}", "issued": "Issued", "failed": "Failed at {{step}}"},
    "step": {"client": "customer", "draft": "draft", "finalize": "numbering", "paid": "payment", "pdf": "PDF", "send": "sending", "credit": "credit note"},
    "vat": "VAT",
    "total": "Total incl. VAT",
    "amountExcl": "Excl. VAT",
    "credits": "Credits invoice {{number}}",
    "creditedBy": "Credited by {{number}}",
    "qontoRef": "Qonto id",
    "channel": "Sent by",
    "channels": {"mail": "email", "einvoice": "e-invoice"},
    "attempts": "Attempts",
    "lastError": "Last error",
    "billedTo": "Billed to",
    "qontoNote": "Issued through Qonto, which numbers it: it changes only by a credit note.",
    "retry": "Retry",
    "retried": "Back to the invoicing worker.",
    "creditNote": "Issue a credit note",
    "creditTitle": "Credit note for the whole invoice",
    "creditMessage": "Qonto issues a credit note for the whole of this invoice, which cancels it in Qonto, and it is mailed to the customer. This cannot be undone.",
    "creditReason": "Reason (printed on the credit note)",
    "creditQueued": "Credit note queued: the invoicing worker issues it through Qonto."
  },
  "credits": {
    "title": "Credits",
    "subtitle": "Monthly credits against pack credits, for every organization, over its current period.",
    "monthly": "Monthly credits",
    "packs": "Pack credits",
    "allocated": "Allocated this period",
    "spent": "Spent",
    "left": "Left (lost if unspent at renewal)",
    "packSpent": "Drawn this period",
    "packBalance": "Balance outstanding",
    "packExpired": "Expired unused",
    "packsSold": "Sold (ever)",
    "packsGiven": "Given by staff (ever)",
    "organization": "Organization",
    "offer": "Offer",
    "monthlyTotal": "Price / month",
    "monthlyUse": "Monthly credits used",
    "nextExpiry": "Next expiry",
    "noOffer": "no subscription",
    "unlimited": "unlimited",
    "exhausted": "exhausted",
    "filterOffer": "Offer",
    "onlyPacks": "Only organizations drawing on packs",
    "note": "Past periods are not kept: what was left of the monthly credits at a renewal is not recorded.",
    "inCurrency": "Each organization's credits are in its own currency, never converted; the totals above add them up in euros at today's rates. The price per month is in the subscription's currency.",
    "prorated": "prorated",
    "proratedHint": "Offer changed on {{date}}, during the period: the monthly credits count the new tier's {{full}} for the days left only."
  },
  "contact": {
    "title": "Contact requests",
    "subtitle": "Requests sent through the website's contact form",
    "role": "Line of work",
    "roles": { "modeller": "Modelling", "lender": "Bank / lender", "investor": "Fund / investor", "advisor": "Advisory, audit", "other": "Other" },
    "statusLabel": "Status",
    "status": { "new": "New", "in_progress": "In progress", "done": "Done", "spam": "Spam" },
    "name": "Name",
    "email": "Email",
    "company": "Company",
    "message": "Message",
    "noMessage": "No message: they asked to be contacted.",
    "lang": "Language",
    "page": "Came from",
    "receivedAt": "Received",
    "searchPlaceholder": "Name, email or company",
    "visitor": "Visitor",
    "handling": "Handling",
    "handledBy": "Handled by",
    "handledAt": "Handled at",
    "note": "Internal note",
    "noteHint": "For staff only; the visitor never sees it.",
    "reply": "Reply by email",
    "replySubject": "Your Sculpt request"
  },
  "waitlist": {
    "title": "Waiting list",
    "subtitle": "Signups from the Project Finance Agent page on www.peerception.io",
    "email": "Email",
    "role": "Role",
    "roles": { "modeller": "Modelling", "lender": "Bank / lender", "investor": "Fund / investor", "advisor": "Advisory, audit", "other": "Other" },
    "lang": "Language",
    "createdAt": "Signed up"
  },
  "mail": {
    "title": "Mail outbox",
    "statusLabel": "Status",
    "status": { "queued": "Queued", "sent": "Sent", "failed": "Failed" },
    "to": "To",
    "template": "Template",
    "subject": "Subject",
    "attempts": "Attempts",
    "scheduledAt": "Scheduled",
    "sentAt": "Sent",
    "fields": "Delivery",
    "providerId": "Provider id",
    "attachment": "Attachment",
    "lastError": "Last error",
    "params": "Parameters",
    "preview": "Preview",
    "text": "Text",
    "retry": "Retry now"
  },
  "audit": {
    "title": "Audit trail",
    "when": "When",
    "action": "Action",
    "actionHint": "Prefix, e.g. admin. or invoice.",
    "target": "Target",
    "targetKind": "Target kind",
    "targetId": "Target id",
    "actor": "Actor",
    "data": "Data"
  },
  "quality": {
    "restrictedTitle": "Restricted conversation",
    "restrictedText": "This conversation is out of the review's sample: its organization opted out, or the person objected. Nothing in it calls for the guardrail (no failure, report or thumbs down), so it opens only for a support request, recorded in the audit log.",
    "openForSupport": "Open for a support request",
    "restrictedRow": "Restricted conversation",
    "downloadThread": "Download thread",
    "replay": "Replay on production code",
    "replayTitle": "Replay",
    "accept": "Accept as reference",
    "acceptAgain": "Replace the reference with this",
    "acceptHelp": "Judge this result correct? Accepting freezes what the code produces now as the reference: from then on this conversation is an eval, replayed before every release, and its index version is kept.",
    "acceptReasonPlaceholder": "What this eval protects, in a sentence",
    "goldenTitle": "In the replay corpus",
    "goldenLine": "Reference accepted on {{when}} by {{who}}, code {{version}}, {{calls}} server call(s).",
    "goldenLastRun": "last run: {{outcome}} on {{when}} (code {{version}})",
    "retire": "Retire the reference",
    "replayHelp": "Plays this conversation's server side again on the code running now, with the model's decisions unchanged. It only says whether the result deviates from what the conversation got; nothing is written and Excel is not touched.",
    "reasoning": "Reasoning",
    "plan": "Change plan",
    "planCalls_one": "{{count}} call",
    "planCalls_other": "{{count}} calls",
    "tokens": "{{input}} tokens in · {{output}} out",
    "expandAll": "Expand all",
    "collapseAll": "Collapse all",
    "address": "Address",
    "before": "Before",
    "written": "Written",
    "range": "Range",
    "cells": "cells",
    "pattern": "R1C1 pattern",
    "whatWasWritten": "What was written",
    "arguments": "Arguments",
    "result": "Result",
    "noResult": "No result (the call never answered).",
    "truncated": "Cut at 40,000 of {{chars}} characters.",
    "cellsChanged_one": "{{count}} cell",
    "cellsChanged_other": "{{count}} cells",
    "undone": "Undone",
    "noBefore": "No before-image: the add-in filed no undo entry for this write.",
    "insightsTitle": "Conversation quality",
    "insightsSubtitle": "What users say, what conversations do, what the reviews found.",
    "conversationsTitle": "Conversations",
    "period": "Period",
    "lastDays_one": "Last day",
    "lastDays_other": "Last {{count}} days",
    "organization": "Organization",
    "conversations": "Conversations",
    "conversation": "Conversation",
    "turnsHint_one": "{{count}} turn",
    "turnsHint_other": "{{count}} turns",
    "flagged": "Flagged",
    "flaggedHint": "{{count}} with a thumbs down or a negative signal",
    "satisfaction": "Satisfaction",
    "thumbsHint": "{{up}} up · {{down}} down",
    "responseRate": "Card response rate",
    "responseHint": "{{answered}} answered · {{dismissed}} dismissed",
    "successRate": "Review success rate",
    "reviewedHint": "{{count}} reviewed",
    "reviewSpend": "Review spend",
    "reviewSpendHint": "Peerception's, not billed",
    "sandboxSpend": "Sandbox spend",
    "conversationsPerDay": "Conversations per day",
    "flaggedPerDay": "Flagged conversations per day",
    "failureReasons": "Failure reasons (reviews)",
    "misuse": "Misuse (reviews)",
    "negativeTags": "Why users said no",
    "signals": "Signals",
    "outcomes": "Outcomes (reviews)",
    "categories": "What users ask for",
    "productInsights": "Product insights",
    "perOrganization": "Per organization",
    "thumbs": "Up / down",
    "reviewed": "Reviewed",
    "failures": "Failures",
    "spend": "Provider cost",
    "noReviews": "No review yet.",
    "noRatings": "No rating yet.",
    "searchHint": "Title, email or id",
    "userRating": "User rating",
    "outcomeLabel": "Outcome",
    "severityLabel": "Severity",
    "categoryLabel": "Category",
    "reports": "Reports",
    "reportFilter": { "any": "Ever reported" },
    "reportReason": { "wrong_result": "Wrong numbers or formulas", "damaged_workbook": "Damaged workbook", "inappropriate": "Inappropriate answer", "data_concern": "Data or security concern", "other": "Other" },
    "evalCandidate": "Eval candidate",
    "eval": "Eval",
    "lastActivity": "Last activity",
    "user": "User",
    "turns": "Turns",
    "verdict": "Review",
    "cost": "Cost",
    "cardDismissed": "The rating card was dismissed.",
    "turn": "Turn {{index}}",
    "turnIndex": "index v{{version}}",
    "turnNoIndex": "no index",
    "indexGone": "Index no longer stored",
    "replayRebuilt": "Turn {{turn}} was played on index v{{version}} rebuilt from its sheets by today's code: its catalog format has changed since.",
    "replayMissing": "Turn {{turn}}: index v{{version}} is no longer stored, so its operations were not played.",
    "worstTurn": "Worst turn",
    "userSaid": "User",
    "untitled": "Untitled conversation",
    "intent": "Intent",
    "sentiment": "Sentiment",
    "selected": "Read because",
    "selectedFlagged": "flagged",
    "selectedSample": "in the random sample",
    "reviewedAt": "Reviewed",
    "reviewFailed": "The review failed; it is retried when the conversation goes on.",
    "notReviewed": "Not reviewed (neither flagged nor sampled, or not quiet yet).",
    "noCardRating": "No rating of the whole conversation.",
    "facts": "Facts",
    "mode": "Mode",
    "workbook": "Workbook",
    "started": "Started",
    "noMessages": "No messages.",
    "costOf": { "agent": "Turns cost", "index": "Indexation cost", "review": "Review cost", "resume": "Resume summary cost", "sandbox": "Sandbox cost" },
    "rating": { "up": "Up", "down": "Down" },
    "outcome": { "success": "Success", "partial": "Partial", "failure": "Failure", "abandoned": "Abandoned", "unclear": "Unclear" },
    "severity": { "none": "None", "low": "Low", "medium": "Medium", "high": "High" },
    "category": { "build": "Build", "modify": "Modify", "explain": "Explain", "audit": "Audit", "fix": "Fix", "format": "Format", "other": "Other" },
    "reason": { "wrong_formula": "Wrong formula", "misunderstood": "Misunderstood", "too_slow": "Too slow", "broke_sheet": "Broke the sheet", "wrong_output": "Wrong output", "too_many_steps": "Too many steps", "tool_failure": "Tool failure", "gave_up": "Gave up", "ignored_instruction": "Ignored an instruction", "hallucination": "Hallucination", "other": "Other" },
    "tag": { "wrong_formula": "Wrong formula", "misunderstood": "Misunderstood", "too_slow": "Too slow", "broke_sheet": "Broke the sheet", "wrong_output": "Wrong output", "too_many_steps": "Too many steps", "accurate": "Accurate", "understood": "Understood", "fast": "Fast", "saved_time": "Saved time", "other": "Other" },
    "misuseKind": { "off_scope": "Off scope", "extraction_attempt": "Asked for its instructions", "injected_instruction": "Instruction in the content" },
    "signal": { "reported": "Reported", "error": "Error", "unavailable": "AI unavailable", "stalled": "Timed out", "iteration_cap": "Step limit", "repeated_calls": "Repeated step", "budget_cap": "Allowance spent", "server_tool_error": "Tool error", "client_tool_error": "Excel refused", "action_rejected": "Write declined", "user_cancel": "Stopped by user", "undo": "Undone", "thumbs_down": "Thumbs down", "turn_started": "Turn started", "turn_done": "Turn done", "disclosure": "Copied its instructions" }
  },
  "billing": {
    "none": "No subscription",
    "subscription": "Subscription",
    "offer": "Offer",
    "periodEnd": "Period ends",
    "status": {
      "trialing": "Trial",
      "active": "Active",
      "past_due": "Past due",
      "ended": "Ended",
      "canceled": "Canceled"
    },
    "period": {
      "label": "Period",
      "trial": "trial",
      "month": "month"
    },
    "reason": {
      "packs_only": "No subscription: the agent stays open while pack credits remain, then closes.",
      "no_subscription": "No active subscription: the agent is closed until an offer is chosen.",
      "free_full": "Every Free place was taken when this organization was created: it has no subscription until staff or an admin choose an offer.",
      "trial_ended": "The trial has ended: the agent is closed until an offer is paid.",
      "payment_overdue": "A renewal is overdue: the agent is closed until it is paid.",
      "member_cap_reached": "member cap reached",
      "user_cap_reached": "user cap reached",
      "limit_reached": "pool and credits spent"
    },
    "pool": "Monthly credits",
    "credits": "Credits",
    "price": "Price",
    "free": "Free",
    "perMonthHt": "/ month excl. VAT",
    "perSeat": "per user / month",
    "seats": "Seats",
    "seatsUsed": "{{used}} used of {{seats}} (members + pending invitations)",
    "allowancePerSeat": "Credits per seat",
    "userCap": "Cap per member",
    "memberCap": "Member cap",
    "startedAt": "Started",
    "grandfathered": "older version",
    "trialDays": "trial, {{days}} days",
    "scheduled": "Scheduled at the period's end: {{offer}} × {{seats}}, on {{date}}.",
    "scheduledTier": "Scheduled at the period's end: {{offer}} × {{seats}} with the {{tier}} tier, on {{date}}.",
    "tier": "Credit tier",
    "tierPart": "{{price}} ({{usage}} of credits)",
    "withTiers": "credit tier",
    "cancelsAt": "Cancels at the period's end ({{date}}).",
    "setTitle": "Put on an offer now",
    "setHint": "Staff move, no order: applies at once (a new version or offer starts a new period; the same version only changes the seats). Private and older versions included.",
    "switchesCurrency": "This version is in {{to}}: the organization moves from {{from}} to {{to}}, which is refused once it has paid an order.",
    "offerVersion": "Offer and version",
    "chooseVersion": "Choose…",
    "applyNow": "Apply now",
    "setConfirm": "{{name}} moves to {{offer}} with {{seats}} seat(s) now, without an order. A new period starts today.",
    "setSeatsConfirm": "{{name}} keeps {{offer}}, now with {{seats}} seat(s). The period is unchanged.",
    "set": "Subscription updated.",
    "extendTitle": "Extend the period",
    "days": "Days",
    "extendHint": "A longer trial, or a courtesy delay before renewal.",
    "extend": "Extend",
    "extended": "Period extended by {{days}} day(s).",
    "grantTitle": "Give credits",
    "amountIn": "Amount ({{currency}})",
    "expires": "Expires",
    "note": "Note",
    "notePlaceholder": "commercial gesture, incident…",
    "grant": "Give",
    "granted": "Credits given.",
    "creditsTitle": "Credits",
    "source": "Source",
    "remaining": "Remaining",
    "noCredits": "No credits.",
    "expired": "expired",
    "grantSource": {
      "pack": "Pack bought",
      "staff": "Given by staff"
    },
    "prorated": "Prorated: the offer changed on {{date}}, during the period, so the new tier's monthly credits only count for the days left. Full {{full}} from {{next}}."
  },
  "offers": {
    "title": "Offers",
    "subtitle": "The catalogue: public offers are on the pricing page; private ones are for deals staff set by hand.",
    "new": "New offer",
    "newSubtitle": "Its first version's terms can be edited freely until someone subscribes.",
    "identity": "Offer",
    "terms": "Terms",
    "key": "Key",
    "keyHint": "Lowercase, digits, dashes; never changes.",
    "currency": "Currency",
    "currencyHint": "Every amount of the offer is in it; fixed once created. The same key in another currency is another offer.",
    "name": "Name",
    "description": "Description",
    "descriptionHint": "Shown on the pricing page.",
    "sort": "Order",
    "placesLimit": "Places",
    "placesTaken": "Current subscriptions allowed at once; taken: {{places}}. Empty = no limit.",
    "version": "Version",
    "publicHint": "Public: on the pricing page, customers can choose it",
    "activeHint": "Active: can be subscribed to",
    "public": "public",
    "private": "private",
    "inactive": "inactive",
    "older": "older version",
    "visibility": "Visibility",
    "subscribers": "Subscribers",
    "seats": "Seats",
    "isTrial": "Trial offer (free, for a number of days, never renews)",
    "trialDays": "Trial length (days)",
    "trialFor": "trial · {{days}} days",
    "pricePerSeat": "Price per user / month",
    "pricePerSeatHint": "In the offer's currency, excluding VAT.",
    "allowancePerSeat": "Credits per user / month",
    "trialAllowance": "Credits for the whole trial",
    "allowanceHint": "In the offer's currency at client price, added to the organization's pool. Empty = unlimited.",
    "userCap": "Cap per member / month",
    "userCapHint": "What one member may draw from the pool. Empty = no cap.",
    "noCap": "no cap",
    "minSeats": "Min users",
    "maxSeats": "Max users",
    "maxSeatsHint": "Empty = no maximum.",
    "tiers": "Credit tiers",
    "tiersHint": "Monthly price excluding VAT → credits it gives (at client price), both in the offer's currency, added to the seats' price and to the monthly credits. None = no choice.",
    "tierPrice": "Price",
    "tierUsage": "Credits",
    "addTier": "Add a tier",
    "removeTier": "Remove this tier",
    "features": "Feature lines",
    "featuresHint": "One per line, shown on the pricing page (12 at most).",
    "keyAndNameRequired": "Key and name are required.",
    "detailSubtitle": "Current version: v{{version}} · {{count}} current subscriber(s) across its versions.",
    "currentTerms": "Current terms (v{{version}})",
    "lockedNotice": "Version {{version}} is in use ({{count}} current subscriber(s)): saving makes version {{version}} + 1 for new subscribers; current subscribers keep version {{version}} until you migrate them.",
    "unlockedNotice": "Nobody has subscribed to this version yet: it can be edited in place.",
    "saveAsNewVersion": "Save as version {{version}}",
    "newVersionTitle": "Create version {{version}}",
    "newVersionMessage": "New subscriptions will take the new terms. The {{count}} current subscriber(s) of version {{version}} keep their terms (grandfathered) until migrated.",
    "versionCreated": "Version {{version}} created; current subscribers keep their version.",
    "termsSaved": "Version {{version}} saved.",
    "versions": "Versions",
    "versionsHint": "A version is frozen once a subscription used it. Migrating moves its subscribers to another version at their first renewal after the chosen date; their admins are mailed now.",
    "current": "current",
    "createdAt": "Created",
    "locked": "Frozen",
    "migrate": "Migrate subscribers",
    "migrateTitle": "Migrate version {{version}} ({{count}} subscriber(s))",
    "migrateMessage": "Today or earlier: each subscription moves now and keeps its period; the next renewal bills the new terms. A later date: it moves at its first renewal on or after that date. Their admins get a notice mail now, with the real date.",
    "migrateTo": "To version",
    "migrateFrom": "From",
    "migrateFromHint": "Give at least {{days}} days' notice.",
    "migrated": "{{count}} subscription(s) will move at their first renewal from {{date}}.",
    "migratedNow": "{{count}} subscription(s) moved now to the new version."
  },
  "packs": {
    "title": "Credit packs",
    "subtitle": "Prepaid credits customers buy once their monthly credits are spent. Used oldest-expiring first.",
    "new": "New pack",
    "name": "Name",
    "price": "Price",
    "priceHint": "In the pack's currency, excluding VAT.",
    "credit": "Credits",
    "creditHint": "In the pack's currency, at client price.",
    "validity": "Validity",
    "validityHint": "Months from payment; empty = never expires.",
    "noExpiry": "never expires",
    "months": "{{count}} months",
    "publicHint": "Public: customers can buy it in the portal",
    "activeHint": "Active: can be bought",
    "editHint": "Changes apply to new orders; pending orders keep their price, bought credits their amount."
  },
  "prices": {
    "title": "Prices",
    "subtitle": "The currencies Sculpt is sold in, their rates, and every offer and pack priced in each currency. Immediate, no deploy.",
    "currencies": "Currencies",
    "currency": "Currency",
    "rate": "Rate",
    "onSale": "On sale",
    "notOnSale": "not on sale",
    "fixed": "fixed",
    "updated": "Updated",
    "rateHint": "The rate is what one unit is worth in euros (USD 0.90: one dollar is worth €0.90). It turns a request's price, counted in euros, into this currency; the USD rate also turns into euros what providers billing in dollars charge (Anthropic). Offer prices are not converted from it: each currency's prices are set in the table below. A currency on sale can be offered to customers.",
    "rateChangeHint": "Changing a rate reprices only the requests after it, in this currency (and, for USD, every Anthropic request). No balance moves.",
    "newCode": "Code",
    "addCurrency": "Add a currency",
    "addHint": "Starts not on sale: price it below, then put it on sale.",
    "badCode": "A currency code has three letters (USD, GBP).",
    "badRate": "The rate must be a number above zero.",
    "codeListed": "{{code}} is already listed: change its rate in its row.",
    "currencySaved": "Currency saved.",
    "delete": "Delete",
    "deleteTitle": "Delete {{code}}?",
    "deleteMessage": "Only a currency nothing uses can go: no organization, offer, pack, order, invoice, request or credit in it. USD stays: its rate also prices Anthropic's costs.",
    "deleteOnSale": "Take it off sale first.",
    "currencyDeleted": "Currency deleted.",
    "table": "Price table",
    "tableHint": "Each column is a currency, edited on its own. “—” = not priced in that currency. Amounts are in the column's currency.",
    "editing": "Editing the {{currency}} prices",
    "editHint": "A row left wholly blank is not created. A row not yet in {{currency}} is created from the euro one (name, visibility, seats, features), its euro values shown as a reference. Blank allowance = unlimited, blank cap = no cap, blank tier credits = the tier's price. New terms on an offer with subscribers make a new version; theirs is kept.",
    "offers": "Offers",
    "packs": "Credit packs",
    "tier": "Tier {{n}}",
    "noCap": "no cap",
    "fromEur": "new, from EUR",
    "versionMeta_one": "v{{version}} · {{count}} subscriber",
    "versionMeta_other": "v{{version}} · {{count}} subscribers",
    "incomplete": "{{name}}: fill every amount of the row, or leave it wholly blank.",
    "pricesSaved": "{{currency}} prices saved.",
    "unpricedOnSale": "{{currency}} is on sale but has no price for: {{names}}. Customers in {{currency}} cannot buy them."
  },
  "orders": {
    "title": "Orders",
    "subtitle": "What organizations bought or owe. Mark an order paid when the payment arrives: it takes effect at once.",
    "organization": "Organization",
    "kindLabel": "Kind",
    "statusLabel": "Status",
    "what": "What",
    "amount": "Amount (excl. VAT)",
    "vat": "VAT",
    "total": "Total (incl. VAT)",
    "createdAt": "Created",
    "paidAt": "Paid",
    "payment": "Payment",
    "showPayments": "Payments",
    "hidePayments": "Hide",
    "kind": {
      "subscribe": "Subscription",
      "change": "Change of offer",
      "seats": "Seats",
      "renewal": "Renewal",
      "pack": "Credit pack"
    },
    "status": {
      "pending": "Pending",
      "paid": "Paid",
      "canceled": "Canceled",
      "failed": "Failed"
    },
    "none": "No orders.",
    "markPaid": "Mark paid",
    "markPaidTitle": "Mark order no. {{id}} paid",
    "markPaidMessage": "Only once the payment has arrived. The order takes effect now (subscription, seats, credits or reactivation) and the customer is mailed.",
    "paid": "Order paid and applied.",
    "canceled": "Order canceled.",
    "draftInvoice": "Draft invoice",
    "openInvoice": "Invoice"
  },
  "errors": {
    "restricted_conversation": "This conversation opens only for a support request.",
    "order_not_paid": "Only a paid order can be refunded.",
    "invalid_effect": "That effect does not apply to this kind of order.",
    "invalid_amount": "The amount must be above zero.",
    "amount_too_high": "The amount is more than what is left to refund on this order.",
    "invoice_not_issued": "This order's invoice is not issued yet: the credit note needs its number. Try again in a few minutes.",
    "refund_refused_by_mollie": "Mollie refused the refund (already refunded, or the payment cannot be refunded): check in Mollie.",
    "no_saved_card": "This organization has no saved card.",
    "payment_provider_unavailable": "Mollie is not answering right now: try again in a few minutes.",
    "vat_review_pending": "This order's VAT waits for its VAT number to be settled: settle it first (VAT to check).",
    "invalid_country": "The country must be a two-letter ISO code.",
    "invalid_customer_kind": "The customer is a company or a sole trader.",
    "invalid_siren": "A SIREN has 9 digits.",
    "invalid_vat_number": "This VAT number is not well formed.",
    "vat_country_mismatch": "The VAT number must start with the billing country's prefix (Greece: EL, Monaco: FR).",
    "no_vat_number": "The organization has no VAT number.",
    "manual_invoicing_retired": "Invoices are now issued through Qonto for every paid order: they can no longer be made by hand.",
    "issued_by_qonto": "This invoice was issued through Qonto: it changes only by a credit note.",
    "not_failed": "Only a failed invoice can be retried.",
    "not_creditable": "Only an invoice issued through Qonto can be credited.",
    "already_credited": "This invoice already has a credit note.",
    "currency_locked": "The currency cannot change any more: the organization has paid an order in it.",
    "currency_not_supported": "No exchange rate is configured for this currency.",
    "currency_fixed": "An offer's currency cannot change: create the offer in the other currency.",
    "currency_mismatch": "The target is in another currency.",
    "key_taken": "This key is already used in this currency.",
    "eur_fixed": "The euro is the ledger's currency: its rate is fixed at 1 and it is always on sale.",
    "tiers_mismatch": "An offer with tiers in euros must be priced with as many tiers in this currency (tiers match by rank).",
    "reference_missing": "There is no euro offer or pack with this key to start from: create it in euros first.",
    "duplicate_tier": "Two tiers of an offer have the same price.",
    "usd_prices_providers": "USD cannot be deleted: its rate also prices what Anthropic charges in dollars.",
    "currency_on_sale": "Take the currency off sale before deleting it.",
    "currency_in_use": "This currency is in use (an organization, offer, pack, order, invoice, request or credit): it cannot be deleted."
  },
  "profile": {
    "hint": "Sculpt is sold to professionals only. The VAT of every order follows this profile: country, and elsewhere in the EU the VAT number checked with VIES.",
    "complete": "ready to invoice",
    "incomplete": "incomplete",
    "kindLabel": "Customer",
    "kind": {
      "company": "Company",
      "individual": "Sole trader"
    },
    "nameIndividual": "First and last name",
    "street": "Street",
    "zip": "Postal code",
    "city": "City",
    "country": "Country",
    "siren": "SIREN",
    "sirenHint": "Required for a French customer (9 digits).",
    "registration": "Registration number",
    "registrationHint": "Customer outside France, optional: printed as typed on their invoices. Ignored for a French customer (SIREN).",
    "paymentMethod": "Payment",
    "payment": {
      "card": "Card",
      "transfer": "Bank transfer"
    },
    "transferHint": "Staff only: orders are marked paid by hand. No screen offers it to the customer.",
    "legacyAddress": "Former address (free text)",
    "legacyAddressHint": "Kept from before the structured address; not used for VAT or invoices."
  },
  "payments": {
    "kind": "Kind",
    "online": "Online payment",
    "recurring": "Automatic charge",
    "revoke": "Revoke the card",
    "revokeTitle": "Revoke the saved card?",
    "revokeMessage": "The card {{card}} will no longer be charged automatically: the customer will pay the next renewals by hand from their account. The mandate is revoked at Mollie.",
    "revoked": "Card revoked: renewals will no longer be charged automatically.",
    "title": "Card payments of order no. {{id}}",
    "none": "No card payment for this order.",
    "byCard": "Card",
    "status": {
      "open": "Open",
      "pending": "Pending",
      "authorized": "Authorized",
      "paid": "Paid",
      "failed": "Failed",
      "canceled": "Canceled",
      "expired": "Expired"
    },
    "attempt": "Attempt",
    "amount": "Amount (incl. VAT)",
    "card": "Card",
    "failure": "Failure reason",
    "createdAt": "Created",
    "paidAt": "Paid",
    "expiresAt": "Expires",
    "dashboard": "Open in Mollie",
    "cardTitle": "Saved card",
    "noCard": "No saved card: the organization has not paid by card yet.",
    "cardLabel": "Card",
    "cardExpires": "Expires",
    "customer": "Mollie customer",
    "mandate": "Mandate"
  },
  "vat": {
    "title": "VAT to check",
    "subtitle": "VAT numbers VIES could not answer for. Their orders are held until you settle the number, or VIES answers on a later pass.",
    "none": "No VAT number waiting.",
    "onRecord": "VIES record",
    "noAnswer": "no answer yet",
    "since": "Since",
    "held": "Held orders",
    "heldOrders_one": "{{count}} order · {{amount}}",
    "heldOrders_other": "{{count}} orders · {{amount}}",
    "status": {
      "none": "not checked",
      "valid": "valid",
      "invalid": "not valid",
      "review": "to check"
    },
    "scheme": {
      "reverse_charge": "Reverse charge",
      "outside_scope": "VAT not applicable",
      "review": "Waiting for VAT check"
    },
    "rate": "{{rate}} %",
    "markValid": "Number valid",
    "markInvalid": "Number not valid",
    "validTitle": "{{number}} is valid",
    "invalidTitle": "{{number}} is not valid",
    "validMessage": "The customer is reverse-charged (0 %). Held orders become payable and the organization's admins are mailed.",
    "invalidMessage": "The customer pays French VAT (20 %). Held orders become payable and the organization's admins are mailed.",
    "decided": "VAT number {{status}}.",
    "decidedReleased": "VAT number {{status}}; orders now payable: {{orders}}.",
    "cardTitle": "VAT number {{number}}",
    "recheck": "Check again with VIES",
    "reviewHint": "VIES could not answer for this number: its orders are held. Check the company's details, then settle it.",
    "checkedAt": "Checked by VIES",
    "registeredName": "Registered name",
    "registeredAddress": "Registered address",
    "consultation": "Consultation no.",
    "settled": "Settled",
    "settledByStaff": "by staff, {{date}}",
    "settledByVies": "by VIES, {{date}}",
    "salesTitle": "EU distance sales",
    "salesHint": "Orders charged French VAT to customers elsewhere in the EU without a confirmed VAT number. Past {{threshold}} in a year, the customer's country's VAT applies from that sale on (OSS).",
    "salesWarning": "past the warning at {{warning}}",
    "salesOver": "over the threshold"
  },
  "refunds": {
    "show": "Refunds",
    "hide": "Hide",
    "title": "Refunds of order no. {{id}}",
    "none": "No refund for this order.",
    "when": "Date",
    "amount": "Amount incl. VAT",
    "how": "How",
    "status": "Status",
    "reason": "Reason",
    "effect": "Effect",
    "creditNote": "Credit note",
    "openCreditNote": "Open the credit note",
    "toCard": "Card (Mollie)",
    "byTransfer": "Transfer (by you)",
    "statuses": {
      "queued": "Queued",
      "pending": "Pending",
      "processing": "Processing",
      "refunded": "Refunded",
      "failed": "Failed",
      "canceled": "Canceled"
    },
    "effects": {
      "none": "None",
      "cancel_at_period_end": "Cancel at the period's end",
      "cancel_now": "Cancel now",
      "remove_credits": "Take back the unused credits"
    },
    "hintCard": "The money goes back to the customer's card through Mollie, and a credit note of the same amount is issued in Qonto. Left to refund: {{left}}.",
    "hintTransfer": "Order paid by transfer: a credit note is issued in Qonto, but you send the money to the customer. Left to refund: {{left}}.",
    "amountLabel": "Amount incl. VAT",
    "amountHint": "At most {{left}}.",
    "reasonLabel": "Reason",
    "reasonHint": "Printed on the credit note.",
    "effectLabel": "Effect on the subscription or the credits",
    "refund": "Refund",
    "confirmTitle": "Refund order no. {{id}}?",
    "confirmCard": "{{amount}} will go back to the customer's card through Mollie, and a credit note of that amount will be issued in Qonto. This cannot be undone.",
    "confirmTransfer": "A credit note of {{amount}} will be issued in Qonto. The order was paid by transfer: send the money to the customer yourself.",
    "done": "Refund of {{amount}} recorded.",
    "rounded": "The amount was rounded to the cent below: the nearest a one-line credit note can show.",
    "nothingLeft": "Everything was refunded on this order.",
    "chargeback": "Chargeback"
  },
  "monthly": {
    "title": "Month",
    "subtitle": "The month's paid orders, refunds and chargebacks, to reconcile Mollie's settlements and the bank account.",
    "month": "Month",
    "currency": "Currency",
    "paidOrders": "Paid orders",
    "amount": "Total excl. VAT",
    "vat": "VAT",
    "total": "Total incl. VAT",
    "byCard": "Of which by card",
    "byCardHint": "To find in Mollie's settlements (less its fees).",
    "byTransfer": "Of which by transfer",
    "refunds_one": "{{count}} refund",
    "refunds_other": "{{count}} refunds",
    "chargebacks_one": "{{count}} chargeback",
    "chargebacks_other": "{{count}} chargebacks"
  },
  "issues": {
    "title": "Issues",
    "new": "New issue",
    "create": "Create",
    "newFromThis": "New issue",
    "linkToIssue": "Link to issue…",
    "titleLabel": "Title",
    "titlePlaceholder": "What is wrong, in one line",
    "descriptionLabel": "Description",
    "noDescription": "No description yet.",
    "severityLabel": "Severity",
    "statusLabel": "Status",
    "labelsLabel": "Labels",
    "labelsHint": "Separated by commas",
    "searchOpen": "Search the open issues",
    "searchHint": "Title, description or #number",
    "noneFound": "No open issue matches.",
    "status": { "open": "Open", "investigating": "Investigating", "fixed": "Fixed", "wont_fix": "Won't fix", "duplicate": "Duplicate" },
    "severity": { "low": "Low", "medium": "Medium", "high": "High", "critical": "Critical" },
    "statusFilter": { "open": "Open and investigating", "closed": "Closed", "all": "All" },
    "issueFilter": { "open": "An open issue", "any": "Any issue", "none": "No issue" },
    "evidence": "Evidence",
    "affected": "Users · orgs",
    "affectedValue": "{{users}} · {{orgs}}",
    "owner": "Owner",
    "nobody": "Nobody",
    "lastSeen": "Last seen",
    "updated": "Last change",
    "closed": "Closed",
    "users": "Users",
    "organizations": "Organizations",
    "reach": "Reach",
    "kind": { "conversation": "Conversation", "report": "Report", "review": "Review", "signal": "Signal" },
    "kindPlural": { "conversation": "Conversations", "report": "Reports", "review": "Reviews", "signal": "Signals" },
    "kindCount": { "conversation_one": "{{count}} conversation", "conversation_other": "{{count}} conversations", "report_one": "{{count}} report", "report_other": "{{count}} reports", "review_one": "{{count}} review", "review_other": "{{count}} reviews", "signal_one": "{{count}} signal", "signal_other": "{{count}} signals" },
    "evidenceTitle_one": "Evidence ({{count}})",
    "evidenceTitle_other": "Evidence ({{count}})",
    "noEvidence": "Nothing linked yet.",
    "notFound": "No longer exists",
    "unlink": "Unlink",
    "linkKind": "Kind",
    "linkRef": "Reference",
    "linkRefHint": "Thread id, or the report, review or signal number",
    "addLink": "Link",
    "timeline": "Timeline",
    "comment": "Comment",
    "commentPlaceholder": "Findings, reproduction, next step…",
    "edited": "edited",
    "workflow": "Workflow",
    "duplicateOf": "Duplicate of #",
    "fixRefs": "Fix",
    "fixLabel": "MR, commit or release (e.g. sculpt-api !131)",
    "addFix": "Add",
    "remove": "Remove",
    "openedBy": "Opened by {{who}}",
    "backToList": "All issues",
    "editTitle": "Edit the issue",
    "reportTitle": "Report",
    "noneOnConversation": "No issue on this conversation.",
    "openBadge_one": "{{count}} issue",
    "openBadge_other": "{{count}} issues",
    "openStat": "Open issues",
    "openStatHint": "{{reports}} reports · {{opened}} opened · {{closed}} closed in the period",
    "resolve": "Resolve",
    "resolveTitle": "Resolve the issue",
    "resolutionHint": { "fixed": "The problem is gone: say what fixed it", "wont_fix": "Known, and staying as it is", "duplicate": "Another issue already covers it" },
    "fixedBy": "Fixed by",
    "fixUrl": "Link",
    "optional": "Optional",
    "resolveNote": "Note",
    "resolveNoteHint": "Added to the timeline as a comment",
    "resolveNotePlaceholder": "What was found, what changed",
    "resolveAs": "Resolve as {{status}}",
    "reopen": "Reopen",
    "closedAs": { "fixed": "Fixed", "wont_fix": "Won't fix", "duplicate": "Duplicate" },
    "closedByLine": "by {{who}}, {{when}}",
    "via": { "report": "A user's report", "review": "Review ({{model}})" },
    "openedVia": { "report": "Opened by a user's report", "review": "Opened by the review" },
    "event": { "created": "opened the issue, severity {{severity}}", "title": "changed the title", "description": "changed the description", "commentEdited": "edited a comment", "status": "status {{from}} → {{to}}", "severity": "severity {{from}} → {{to}}", "owner": "owner {{from}} → {{to}}", "labels": "labels {{from}} → {{to}}", "fixRefs": "fix {{from}} → {{to}}", "linked": "linked a {{kind}}", "unlinked": "unlinked a {{kind}}" },
    "regression": "regression",
    "beforeAfter": "Before / after",
    "before": "Before",
    "after": "After",
    "exportForClaude": "Export for Claude (.md)",
    "copyForClaude": "Copy for Claude",
    "copied": "Copied",
    "exportHelp": "The issue, its history and its conversations' transcripts as Markdown. Each conversation exported is audited."
  },
  "sandbox": {
    "fromHere": "Sandbox from here",
    "fromHereHelp": "Open a sandbox from this message: the workbook as it was then and the conversation before it. The user sees nothing and pays nothing.",
    "notRecorded": "This turn predates the recording of its index version: it cannot be copied.",
    "openButton": "Open in sandbox",
    "openHelp": "Open a sandbox from the first turn that can be copied. To start at another message, use “Sandbox from here” on it.",
    "nothingPlayable": "No turn of this conversation can be copied: its index versions are no longer stored, or it predates their recording.",
    "reason": "Reason",
    "approveAllLabel": "Approve every confirmation (otherwise each one waits for you)",
    "title": "Sandbox",
    "listTitle": "Sandboxes",
    "listSubtitle": "Conversations copied for staff to play again. Each one is deleted 30 days after its last turn.",
    "none": "No sandbox yet.",
    "conversation": "Conversation",
    "staff": "Staff",
    "model": "Model",
    "turnsPlayed": "Turns",
    "fromTo": "from {{from}}, next {{next}}",
    "cost": "Cost (Peerception's)",
    "state": "State",
    "states": { "idle": "Idle", "running": "Running", "waiting": "Waiting for you", "failed": "Failed" },
    "lastActivity": "Last activity",
    "about": "This sandbox",
    "startedAt": "Started at",
    "startedAtValue": "turn {{turn}}, index v{{version}}",
    "approveAll": "Approves every confirmation",
    "expires": "Deleted after",
    "recordedTurns": "What the user sent",
    "documents_one": "{{count}} attachment",
    "documents_other": "{{count}} attachments",
    "play": "Play",
    "playNext": "Play turn {{index}}",
    "noNext": "Every recorded turn played",
    "waitingQuestion": "The agent asks a question",
    "waitingConfirmation": "These calls wait for confirmation",
    "answer": "Answer",
    "approve": "Approve",
    "refuse": "Refuse",
    "running": "The turn is running…",
    "yourMessage": "Your message",
    "messagePlaceholder": "Ask the agent something in this sandbox…",
    "send": "Send",
    "cancel": "Stop the turn",
    "delete": "Delete",
    "deleteTitle": "Delete this sandbox?",
    "deleteMessage": "Its copy of the workbook and its conversation are deleted. The user's conversation is not touched.",
    "fidelityFunctions": "Not computed as Excel would: the simulator lacks {{functions}} ({{cells}} recalculated cells).",
    "fidelityLoops_one": "A circular reference was computed as 0 (iterative calculation off or unknown): {{count}} cell.",
    "fidelityLoops_other": "Circular references were computed as 0 (iterative calculation off or unknown): {{count}} cells.",
    "comparison": "Played again beside what happened",
    "comparedTurns": "user's turn {{recorded}} · sandbox turn {{sandbox}}",
    "sameTools": "Same tools",
    "otherTools": "Other tools",
    "samePlans": "Same plans",
    "otherPlans": "Other plans",
    "pane": { "recorded": "User's turn {{index}}", "typed": "Typed by staff", "thinking": "Thinking…", "reading": "Reading the model…", "planning": "Planning the change…", "excel": "Working in Excel…", "waiting": "Waiting for you", "userTook": "user's turn: {{time}}", "committed": "saved as v{{version}}", "failed": "failed", "cancelled": "stopped", "running": "running", "waitingState": "waiting", "details": "details", "hideDetails": "hide details" },
    "recorded": "User",
    "sandbox": "Sandbox"
  }
}
